import { useSelector } from "react-redux";
import { getGalleryImages } from "../../../../redux/selectors/webConfigSelector";
import { CgArrowLongRight } from "react-icons/cg";
import { Gallery } from "../../../../components/common/Gallery";
import * as S from "./Gallery.style";
import InstagramPosts from "../InstagramPosts/InstagramPosts";

const GalleryPage = () => {
  const galleryImages = useSelector(getGalleryImages) || {};
  const { web = [], mobile = [] } = galleryImages || {};

  const handleAllPictures = () => {
    window.open("https://www.instagram.com/bingetown_in/");
  };

  return (
    <>
      <S.GalleryContainer>
        <S.Heading>100k+ followers on Instagram!</S.Heading>
        <InstagramPosts />
      </S.GalleryContainer>

      <S.MwebGalleryContainer>
        <S.Heading>100k+ followers on Instagram!</S.Heading>
        <InstagramPosts />
      </S.MwebGalleryContainer>
    </>
  );
};

export default GalleryPage;
